import { FC } from 'react'
import { Address } from 'graphql/types'
import Accordion, { TProps as AccordionItemsProps } from 'components/Accordion'
import Typography from 'components/Typography'
import { searchCityInfoFAQExpand } from 'pages/imoveis/events'
import { FAQ, cityDescription } from './content'
import styles from './CityInfo.module.scss'

export type TProps = {
  address?: Address
}

const CityInfo: FC<TProps> = ({ address }) => {
  if (!address) return null

  const citySlug = address.citySlug as string
  const description = cityDescription[citySlug]

  const itemsFAQ = FAQ[
    address.citySlug as string
  ] as AccordionItemsProps['items']

  if (!description && !itemsFAQ) return null

  return (
    <div className={styles.ecCityInfoContainer}>
      <div className={styles.ecCityDescriptionContainer}>
        <Typography as="h2" variant="Title" bold>
          Conheça {address.city}
        </Typography>
        <Typography as="h3" variant="TitleSmall" bold>
          Como é morar em {address.city}
        </Typography>
        {description}
      </div>

      {itemsFAQ && (
        <div className={styles.ecFaqContainer}>
          <Typography as="h3" variant="TitleSmall" bold>
            Perguntas frequentes sobre {address.city}
          </Typography>
          <Accordion
            items={itemsFAQ}
            onExpand={(question) => {
              searchCityInfoFAQExpand({ city: citySlug, question: question })
            }}
          />
        </div>
      )}
    </div>
  )
}

export default CityInfo
